import React, { useEffect } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import InlineSvg from "../utils/inline-svg";
import { assetIcons, CurrencyIcon } from "../../constants/assets";
import GradientButton from "../utils/gradient-button";
import englishTranslations from "../../i18n/translations/en";
import { darkColors } from "../../theme/colors";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "../../constants/routes";

export default function WinningNotificationComponent() {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const Value = location.state?.Value;
  const Message = location.state?.Message;
  const navigate = useNavigate();
  useEffect(() => {
    if (!Value || !Message) {
      navigate(routes.home);
    }
  });

  return (
    <Box
      sx={{
        height: "100vh",
        bgcolor: "black",
        color: "white",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box mt={14}>
          <InlineSvg url={assetIcons.congrats} />
        </Box>
        <Typography mt={2} fontSize={28} fontFamily={"MontserratBold"}>
          Congratulations
        </Typography>
        <Typography mt={2} fontSize={20} fontFamily={"MontserratBold"}>
          Your total winnings from the race{" "}
          <span style={{ color: darkColors.orange }}>{Message}</span> are{" "}
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              color: darkColors.orange,
            }}
          >
            {Value}
            <CurrencyIcon />
          </Box>
        </Typography>

        <Box mt={5}>
          <GradientButton
            text={englishTranslations.back_to_home}
            onClick={() => (window.location.href = "/home")}
            width={isMediumScreen ? 250 : 350}
          />
        </Box>
        <Box
          mt={5}
          borderTop={2}
          borderBottom={2}
          borderColor={darkColors.borderGray}
        >
          <Typography
            width={isMediumScreen ? 300 : 750}
            sx={{
              my: 4,
            }}
          >
            These winnings are automatically credited to your account balance
          </Typography>
        </Box>
        <Typography
          variant="body2"
          sx={{
            mt: 4,
            mb: 16,
          }}
        >
          If you don't see your winnings, please refresh your page. If the issue
          persists reach out to us
        </Typography>
      </Box>
    </Box>
  );
}
